import './info-tooltip.css';
import React from "react";

const activitiesIndicator = [
  {
    id: 1,
    'activity-indicator': 'standart-mode',
    'activity-description': '- standart workout',
  },
  {
    id: 2,
    'activity-indicator': 'medium-mode',
    'activity-description': '- medium workout',
  },
  {
    id: 3,
    'activity-indicator': 'hard-mode',
    'activity-description': '- hard workout',
  },
  {
    id: 4,
    'activity-indicator': 'water-mode',
    'activity-description': '- water day',
  },
  {
    id: 5,
    'activity-indicator': 'сhallenge-mode',
    'activity-description': '- сhallenge day',
  }
];

const InfoTooltip = () => {
  return (
    <div className='info-container'>
      <div className="info-container__content">
        {activitiesIndicator.map(activity => {
          return (
            <React.Fragment key={activity.id}>
              <div className='info-activity-container'>
                <span className={`indicator ${activity["activity-indicator"]}`}></span>
                <span className='info-activity-description'>{activity["activity-description"]}</span>
              </div>
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default InfoTooltip;